import type { ComponentType } from 'react';

import {
  Bot,
  Car,
  Cpu,
  Database,
  Factory,
  FlaskConical,
  Globe,
  Package,
  Plane,
  Rocket,
  Satellite,
  Shapes,
  Shield,
  Shirt,
  Wrench,
  Zap,
} from './icons';
import type { IconProps } from './icons';

type IconComponent = ComponentType<IconProps>;

export const IMPORT_DATABASE_ICON_CHOICES: Array<{
  key: string;
  Icon: IconComponent;
}> = [
  { key: 'Package', Icon: Package },
  { key: 'Rocket', Icon: Rocket },
  { key: 'Plane', Icon: Plane },
  { key: 'Cpu', Icon: Cpu },
  { key: 'Shield', Icon: Shield },
  { key: 'FlaskConical', Icon: FlaskConical },
  { key: 'Zap', Icon: Zap },
  { key: 'Factory', Icon: Factory },
  { key: 'Globe', Icon: Globe },
  { key: 'Bot', Icon: Bot },
  { key: 'Satellite', Icon: Satellite },
  { key: 'Shapes', Icon: Shapes },
];

const IMPORT_DATABASE_ICON_MAP: Record<string, IconComponent> = {
  ...Object.fromEntries(
    IMPORT_DATABASE_ICON_CHOICES.map(({ key, Icon }) => [key, Icon]),
  ),
  // Existing sample database keys remain supported.
  Database,
  database: Database,
  Shirt,
  Wrench,
  Car,
};

export const IMPORT_DATABASE_ACCENTS = [
  '#4895ef',
  '#22a549',
  '#f59e0b',
  '#7c3aed',
  '#dc2626',
  '#14b8a6',
] as const;

export const DEFAULT_IMPORT_DATABASE_ICON = 'Package';
export const DEFAULT_IMPORT_DATABASE_ACCENT = '#4895ef';

export const getImportDatabaseIcon = (
  key: string | null | undefined,
): IconComponent =>
  (key && IMPORT_DATABASE_ICON_MAP[key]) ||
  IMPORT_DATABASE_ICON_MAP[DEFAULT_IMPORT_DATABASE_ICON];

export const getImportDatabaseAccent = (
  value: string | null | undefined,
): string =>
  value && (/^#[0-9a-f]{6}$/i.test(value) || /^--[\w-]+$/.test(value))
    ? value
    : DEFAULT_IMPORT_DATABASE_ACCENT;

export const resolveImportDatabaseAccent = (value: string): string =>
  value.startsWith('--') ? `var(${value})` : value;
